import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './BabyPhotoContest.css';
import * as actions from './Actions';
import { fetchInitialData } from "../fetchData";
import Right from '../right/Right';
import Service from '../service/Service';
import MoreLeaderboard from './common/MoreLeaderboard';
import withLocation from "../../withLocation";
import withContext from "../../withContext";
const service = new Service();


class Leaderboard extends Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        let initialData = [];
        let count;
        let record = "yes";
        var dataAry =[];
        

        // if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData'] && window.__initialData__['initialData']['result']) {
        //     initialData = window.__initialData__['initialData']['result'];
        //     delete window.__initialData__;
        // } else {
        //     if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData'] && props.staticContext.initialData['initialData']['result']) {
        //     initialData = props.staticContext.initialData['initialData']['result'];
        //     }
        // }


console.log("🔍 Debug: Starting initialData resolution...");

if (__isBrowser__) {
  console.log("🌐 Environment: Browser detected");

  if (window.__initialData__) {
    console.log("✅ window.__initialData__ found:", window.__initialData__);

    if (window.__initialData__['initialData']) {
      console.log("📦 window.__initialData__['initialData'] exists:", window.__initialData__['initialData']);

      if (window.__initialData__['initialData']['result']) {
        console.log("🎯 Using browser-side initialData.result:", window.__initialData__['initialData']['result']);
        initialData = window.__initialData__['initialData']['result'];

        // Clean up after use
        delete window.__initialData__;
        console.log("🧹 window.__initialData__ deleted after usage");
      } else {
        console.warn("⚠️ window.__initialData__['initialData']['result'] missing");
      }
    } else {
      console.warn("⚠️ window.__initialData__['initialData'] missing");
    }
  } else {
    console.warn("⚠️ window.__initialData__ not found");
  }

} else {
  console.log("🖥️ Environment: Server-side rendering detected");

  if (props.staticContext) {
    console.log("✅ props.staticContext found:", props.staticContext);

    const serverInitial = props.staticContext.initialData;
    if (serverInitial) {
      console.log("📦 props.staticContext.initialData exists:", serverInitial);

      if (serverInitial['initialData'] && serverInitial['initialData']['result']) {
        console.log("🎯 Using server-side initialData.result:", serverInitial['initialData']['result']);
        initialData = serverInitial['initialData']['result'];
      } else {
        console.warn("⚠️ props.staticContext.initialData['initialData']['result'] missing");
      }
    } else {
      console.warn("⚠️ props.staticContext.initialData missing");
    }
  } else {
    console.warn("⚠️ props.staticContext not found");
  }
}

console.log("✅ Final resolved initialData:", initialData);

        
     
        
        console.log("✅ Final initialData =>", initialData);
        
        this.state = {
            initialData: initialData,
            count: 2,
            record : record,
            dataAry: dataAry,
            leatherDetails :[],
            metaDescription: [
                { "name": "description", "content": "Memories Contest - FirstCry Parenting" }
            ]
        }
        this.qnaPageNo = 1;
        this.totalCount = Array.isArray(this.state.initialData?.result)
        ? this.state.initialData.result.length
        : 0;
        if (this.props.params.page && this.props.params.page > 0) {
            this.qnaPageNo = parseInt(this.props.params.page);
        }
        this.maxScroll = 0;
        this.timeout = 0;
    }
    static initialAction(reqUrl, ftk, authData, uId, childData) {    
        // alert('init'); 
        var header = {
            'Content-Type': 'application/json',
            'ftk':  ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        // console.log('reqUrl ', reqUrl);
        // console.log('reqUrl ', reqUrl.split('/'));
        var ConDetailUrl = reqUrl.split('/')[5] ? reqUrl.split('/')[5] : '';
            var url = global.api_url + "contest/getcontestdetails";
            let body = JSON.stringify({ 
                        "pageNo": 1,
                        "pageSize": 10 ,
                        "contestId": ConDetailUrl      
                    })
            return fetchInitialData(url, JSON.stringify(header), body);
    }
    componentDidMount() {
        // var initialData;
        var pagetitle;
        var ConDetailUrl = this.props.location.pathname.split('/');
        if(ConDetailUrl[4] == 'leaderboard'){
            this.setState({ pagetitle: 'Leaderboard' });
        }else{
            this.setState({ pagetitle: 'Entries' });
        }
        if(!this.state.initialData.msg == '-1' || this.state.initialData.result == "Unsuccess"){
            console.log('if componentDidMount ===> ');
            var contestid  = ConDetailUrl[5] ? ConDetailUrl[5] : '';        
            // this.leaderboardAPICall(contestid);
            var dUlr = ConDetailUrl[3] ? ConDetailUrl[3] : '';
            var cTitle;
            this.setState({ cTitle: dUlr });
            var title1 = dUlr.replace(/-/g," ");
            title1 = this.capitalizeFirstLetters(title1);
            this.setState({ title1: title1 });
            this.setState({ conID: contestid });
        }else{
            console.log('elsee componentDidMount contest id ===> ' , this.state.initialData);
            const result = this.state.initialData ? this.state.initialData : [];
            console.log("🔍 Debug: Extracted result from initialData:", result);

            if (Array.isArray(result) && result.length > 0) {
              const contestId = result[0].contestId;
              this.leaderboardAPICall(contestId);
            } else {
              console.warn('⚠️ contestId not found — result is missing or empty:', result);
            }
            // var contestId = this.state.initialData.result[0].contestId;
            // this.leaderboardAPICall(contestId);
        }
        
        if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
            service.showLoader();
        } else {
            localStorage.setItem('leaderboard', JSON.stringify(this.state.initialData));
        }
    
        if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
            service.showLoader();
        } else {
            localStorage.setItem('leaderboard', JSON.stringify(this.state.initialData));
        } 
        
        if(this.state.initialData.result != 'Record Not Found'){
            // this.totalCount = this.state.initialData.result.length;
            this.totalCount = Array.isArray(this.state.initialData?.result)
            ? this.state.initialData.result.length
            : 0;
            console.log(' ---- ', this.totalCount);
            this.pageData = this.pageData.bind(this);
            window.addEventListener("scroll", this.pageData, false);
        }
    }

        // pagination code start=====================
        pageData() {
            // debugger;
            var _this = this;
            clearTimeout(_this.timeout);
            _this.timeout = setTimeout(function () {
                // debugger;
                if (document.getElementsByClassName('data-container')[0]) {
                    var cS = document.getElementsByClassName('data-container')[0].offsetTop;
                    var cH = document.getElementsByClassName('data-container')[0].offsetHeight - 500,
                        wS = window.scrollY - cS;
                        var checkVal = (window.innerHeight + window.scrollY) >= document.body.offsetHeight;
                    if (!(checkVal) && wS > cH) {
                        if (wS > _this.maxScroll && _this.totalCount >= (_this.qnaPageNo * 10)) {
                            _this.maxScroll = wS;
                            ++_this.qnaPageNo;
                            service.showLoader();
                            document.getElementById('pgNo').value = _this.qnaPageNo;
                            _this.LoadAllTypesContestOnScroll(_this.qnaPageNo, 10);
                            // service.hideLoader();
                        } else {
                            return false;
                        }
                    }
                }
            }, 100)
        }
    
        LoadAllTypesContestOnScroll(pageno, size) {
            // debugger;
            var hostUrl = window.location.pathname; 
            var ConDetailUrl = this.props.location.pathname.split('/');
            var dUlr = ConDetailUrl[5];
            // var url = global.api_url + "contest/getleaderboard";
            var url = global.api_ci_url + "MemoriesContest/leaderboardajax";
            var postData = {
                "pageno": pageno,
                "pagesize": size,
                "contestId": dUlr
            }
            service.postServiceCall(url, postData).then((json) => {
                if (json['msg'] == 1) {
                    if (this.state.leatherDetails.length > 0) {
                        if(json['result'].length > 0){
                            this.setState({record : 'yes'})
                        }else{
                            this.setState({record : 'No'})
                        }
                        if (size == (pageno * 10)) {
                            this.setState({ leatherDetails: json['result']});
                        } else {
                            
                            let ary = this.state.leatherDetails;
                            this.setState({ leatherDetails: ary.concat(json['result'])});
                            // this.totalCount = this.state.leatherDetails.length;

                            this.totalCount = Array.isArray(this.state.leatherDetails)
                            ? this.state.initialData.leatherDetails.length
                            : 0;
                            console.log('pageno : '+ pageno +' totalCount '+ this.totalCount )
                        }
                        // service.hideLoader();
                    }
                }
                // service.hideLoader();
                
            }).catch((error) => {
                console.error(error);
                service.hideLoader();

            });
        }
        // paginatoin code end ======================

    
    capitalizeFirstLetters(str){
        return str.toLowerCase().replace(/^\w|\s\w/g, function (letter) {
            return letter.toUpperCase();
        })
    }

    leaderboardAPICall(contestId){
        // debugger;
        if(navigator.onLine) {
            var ConDetailUrl = this.props.location.pathname.split('/');
            var dUlr = ConDetailUrl[5] ? ConDetailUrl[5] : '';
            // console.log('leaderboardAPICall contest id ' , dUlr);
            var postData = {
                "pageno": 0,
                "pagesize": 10,
                "contestId": dUlr
            }
            // var url = global.api_url + "contest/getleaderboard";
            var url = global.api_ci_url + "MemoriesContest/leaderboardajax";
            service.postServiceCall(url, postData).then((json) => {
                if (json['result']) {  
                    console.log('leaderboard data: ',json['result']);              
                    this.setState({ leatherDetails: json['result'] });
                    if(json['result'] != 'Record Not Found'){
                        this.totalCount = json['result'].length;
                        console.log(' ---- ', this.totalCount);
                        // this.pageData = this.pageData.bind(this);
                        // window.addEventListener("scroll", this.pageData, false);
                    }
                }

                
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
        }else{
            service.showAlert("Please Check Internet Connection!!!");
        }
    }
    
    render() {
    // var activeContest = this.state.initialData.result;
    // console.log(this.state.leatherDetails);

    const resultArr = Array.isArray(this.state.initialData)? this.state.initialData: [];
    const contest = resultArr[0] || {};
    console.log("🔍 Debug: Render method contest data:", contest);
        return (
            <main className="main-container">
                <Helmet
                    title={`LeaderBoard: ${ this.state.initialData.result && this.state.initialData.result[0].title ? this.state.initialData.result[0].title :''}- FirstCry Parenting`}
                    meta={this.state.metaDescription ? this.state.metaDescription : 'Memories Contest - FirstCry Parenting'}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a className="R11_9e" href="/">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href="/baby-photo-contest">Memories Contest</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a className="R11_9e" href={`/baby-photo-contest/contest/${contest && contest.title ? actions.loadcontestName(contest.title) : this.state.cTitle}/${contest && contest.contestId ? contest.contestId : this.state.conID}`}>{contest.title? contest.title : this.state.title1}</a></span> 
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span className="R11_9e">{this.state.pagetitle}</span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>{this.state.pagetitle} - { contest.title ? contest.title :this.state.title1}</h1>
                </div>
                <div className="sub-container memoriesContest-cnt left leader-cont">
                    <div className="data-container left  leader-cont">
                        <div className="container_bump">
                        {/* start */}
                        <div className="contest-leaderboard">
                            <input type="hidden" id="page_no" name="page_no" value="2"/>
                            <div className="participant-list past-participant-wrapper" id="leather-list">
                            {this.state.leatherDetails && this.state.leatherDetails.length > 0 && this.state.leatherDetails.map((value, index) =>  
                            <div>
                                {value.isLoginParticipate == 1 &&  
                                <div className="past-participant-details loggedinuser" id={value.memoryId}>
                                    <div className="past-first-det-blc">
                                        <a className="past-parti-img left" href={`/memories/photodetails/${value.memoryId}`}  onClick={() => actions.networkCheck()}>
                                            <img src={value.imageUrl.replace("http://", "https://").replace(/\.(png|jpg|jpeg)$/i, ".webp")} onError={(e) => (e.target.src = value.imageUrl.replace("http://", "https://"))} />
                                        </a>
                                        <div className="past-parti-info left">
                                            <a className="past-parti-det" href={`/memories/photodetails/${value.memoryId}`}  onClick={() => actions.networkCheck()}>
                                                <div className="past-parti-name M15_42">{value.userName}</div>
                                            </a>
                                            <div className="past-parti-rank M16_9e"> Rank : {value.userRank} </div>
                                        </div>
                                    </div>                                    
                                    <ul className="past-parti-contest-det">
                                        <li>
                                            <div className="R15_9e past-nm">Likes</div>
                                            <div className="past-contestlk-count M14_42">{value.likeCount}</div>
                                        </li>
                                        <li>
                                            <div className="R15_9e past-nm">Comments</div>
                                            <div className="past-contestlk-count M14_42">{value.commentCount}</div>
                                        </li>
                                    </ul>
                                </div> 
                                 }                       
                            </div>
                            )}
                            {this.state.leatherDetails && this.state.leatherDetails.length > 0 &&
                                <div className="dash-title M16_pink">Other Participants Position </div>
                            }
                            {this.state.leatherDetails && this.state.leatherDetails.map((value, index) =>  
                            <div>              
                                {value.isLoginParticipate == 0 ? 
                                <div>
                                <div className="past-participant-details" id={value.memoryId}>
                                    <div className="past-first-det-blc">
                                        <a className="past-parti-img left" href={`/memories/photodetails/${value.memoryId}`}  onClick={() => actions.networkCheck()}>
                                            <img src={value.imageUrl.replace("http://", "https://").replace(/\.(png|jpg|jpeg)$/i, ".webp")} onError={(e) => (e.target.src = value.imageUrl.replace("http://", "https://"))} />
                                        </a>
                                        <div className="past-parti-info left">
                                            <a className="past-parti-det" href={`/memories/photodetails/${value.memoryId}`}  onClick={() => actions.networkCheck()}>
                                                <div className="past-parti-name M15_42">{value.userName}</div>
                                            </a>
                                            <div className="past-parti-rank M16_9e"> Rank : {value.userRank} </div>
                                        </div>
                                    </div>                                    
                                    <ul className="past-parti-contest-det">
                                        <li>
                                            <div className="R15_9e past-nm">Likes</div>
                                            <div className="past-contestlk-count M14_42">{value.likeCount}</div>
                                        </li>
                                        <li>
                                            <div className="R15_9e past-nm">Comments</div>
                                            <div className="past-contestlk-count M14_42">{value.commentCount}</div>
                                        </li>
                                    </ul>
                                </div>
                                <MoreLeaderboard eleRef={this} leatherDetails={this.state.leatherDetails} />
                                <input type="hidden" id="pgNo" value="" />
                                </div>
                                :'' 
                                }
                            </div>
                            )}

                        </div>
                            <div className="loader-overlay">          
                            <div className="loader-img">
                                <img src="//parenting.firstcry.com/vaccination/images/ajax-loader-tr.svg" alt="Loader Icon" title="Loader Icon" />
                            </div>
                            </div>
                        </div>
                        {/* end */}
                        </div> 
                    </div>
                </div>
                <Right url={this.props.location.pathname} />
            </main>
        )
    }
}

export default withContext(Leaderboard);
